
export class WalkoutL3RD {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "Walkout L3RD";
    this.scene = "Walkout L3RD";
    this.data = [];
    this.page = 9004;
  }

  async preview({ options }) {
    this.onAir = false;

    await this.updateData({ options, show: 1 });
    // await this.updateData({ options, show: 2 });
    // await this.updateData({ options, show: 3 });
    // await this.updateData({ options, show: 4 });
    await this.sendPreview("page:read " + this.page);
  }
  async animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  async updateData({ options, show }) {
    let xml = await this.getVizPage({ page: this.page, show }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml.payload.field.find((item) => {
        return item.attr.name === "1100";
      }).value = (options?.player?.first_name.toUpperCase()  || "") + " " + (options?.player?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1014";
      }).value = "STYLE - " + (options?.player?.style.toUpperCase() || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1016";
      }).value = "WEIGHT - " + (options?.player?.weight || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1018";
      }).value = "AGE - " + (options?.player?.age || "");
      
      xml.payload.field.find((item) => {
        return item.attr.name === "1101";
      }).value = options?.player?.weightclass?.toUpperCase() || "";

      

      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
        show,
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  update({ options }) {}
}
